import React from 'react';
import MarkupMenuDecorationButton, {
  MarkupMenuDecoration,
} from 'components/text-editor/components/controls/components/markup-menu/components/markup-menu-decoration-button';
import LinkingButtons from './components/linking-buttons';
import {
  Container,
  Button,
  Separator,
} from 'components/text-editor/components/controls/components/markup-menu/style';
import { ReactComponent as HighlightIcon } from 'styles/icons/highlight.svg';
import { ReactComponent as UnderlineIcon } from 'styles/icons/underline.svg';
import { ReactComponent as StrikethroughIcon } from 'styles/icons/strikethrough.svg';
import { ReactComponent as NameIcon } from 'styles/icons/text.svg';
import { AnnotationData } from 'types';

interface MarkupMenuProps {
  showNameEditor: Function;
  isNameButtonDisabled?: boolean;
  isLinkButtonDisabled?: boolean;
  isNameEditorVisible: boolean;
  isNameDisplayVisible: boolean;
  showFinishLinkAction?: boolean;
  showDeleteLinkAction?: boolean;
  deleteLink: (data: AnnotationData) => void;
  startLinking: (data: AnnotationData) => void;
  finishLinking: (data: AnnotationData) => void;
}

const { HIGHLIGHT, STRIKETHROUGH, UNDERLINE } = MarkupMenuDecoration;

export default function MarkupMenu({
  showNameEditor,
  isNameEditorVisible,
  isNameDisplayVisible,
  isNameButtonDisabled,
  isLinkButtonDisabled,
  showDeleteLinkAction,
  showFinishLinkAction,
  startLinking,
  finishLinking,
  deleteLink,
}: MarkupMenuProps) {
  return (
    <Container>
      <Button
        onMouseDown={showNameEditor}
        disabled={
          isNameButtonDisabled || isNameEditorVisible || isNameDisplayVisible
        }
        selected={isNameEditorVisible || isNameDisplayVisible}>
        <NameIcon />
      </Button>
      <Separator />
      <LinkingButtons
        isLinkButtonDisabled={isLinkButtonDisabled}
        showFinishLinkAction={showFinishLinkAction}
        showDeleteLinkAction={showDeleteLinkAction}
        startLinking={startLinking}
        finishLinking={finishLinking}
        deleteLink={deleteLink}
      />
      <MarkupMenuDecorationButton decoration={HIGHLIGHT}>
        <HighlightIcon />
      </MarkupMenuDecorationButton>
      <MarkupMenuDecorationButton decoration={UNDERLINE}>
        <UnderlineIcon />
      </MarkupMenuDecorationButton>
      <MarkupMenuDecorationButton decoration={STRIKETHROUGH}>
        <StrikethroughIcon />
      </MarkupMenuDecorationButton>
    </Container>
  );
}
